import {
  getTaxFiltersFromStorage,
  hasAnyNonDateFilter,
} from "../utils/taxFilters";
import { downloadReport } from "../utils/reportDownload";
import type { TaxFilters } from "../utils/taxFilters";

export { MISSING_PERIOD_MESSAGE } from "../utils/reportDownload";

export const useReportDownload = (
  setIsDownloading: (v: boolean) => void,
  setBackgroudError: (v: string) => void,
) => {
  const download = () =>
    downloadReport<TaxFilters>({
      getFilters: getTaxFiltersFromStorage,
      hasAnyNonDateFilter,
      endpoint: "/report",
      setIsDownloading,
      setBackgroudError,
      getAdditionalQueryParams: (filters) => ({
        flags: filters.flags,
        harmonizationAlert:
          filters.harmon.length === 1 ? filters.harmon[0] : "",
      }),
    });

  return { download };
};
